<i18n>
{
	"en": {
		"title": "Inbound",
		"transportMethod" : "Transport method",
		"endpoint" : "Source",
		"sender" : "Sender",
		"receiver": "Receiver",
		"messageFormat": "Message format",
		"messageType": "Message type",
		"ftps": "ftps?",
		"allowUpdates": "Updates?",
		"endpointPassword": "Password",
		"endpointUsername": "Username",
		"addSetup" : "Add setup",
		"delete" : "Delete Setup?",
		"notifySetupDeleted": "Inbound setup successfully deleted"
	},
	"no": {
		"title": "Inngående",
		"transportMethod" : "Transport metode",
		"endpoint" : "Kilde",
		"sender" : "Sender",
		"receiver": "Mottaker",
		"messageFormat": "Meldings format",
		"messageType": "Meldings type",
		"ftps": "ftps?",
		"allowUpdates": "Updates?",
		"endpointPassword": "Passord",
		"endpointUsername": "Brukernavn",
		"addSetup" : "Legg til oppsett",
		"delete" : "Slett oppsett?",
		"notifySetupDeleted": "Inngående setup slettet"
	}
}
</i18n>
<template>
	<div style="height: calc(100%);">

		<div style="height: 50px; background: #fff; padding: 0px 15px; display: flex; align-items: center; justify-content: space-between;">
			<t-panel-header
				icon="import"
				type="bp"
				:text="$t('title')"
			/>
			<t-icon-button
				icon="plus"
				type="bp"
				appearance="minimal"
				@click="showAddSetting"
			/>
		</div>
		<t-grid
			ref="inboundSettingsGrid"
			:key="'inboundSettingsGridKey'"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="50"
			:items="edipart.inboundSetups"
			selectable
			@rowDoubleClick="editSetting"
		>
			<template v-slot:endpointPassword="{displayValue}">
				<t-password :value="displayValue"/>
			</template>
			<template v-slot:button="{ item }">
				<t-icon-button
					style="padding-left:1em;color:red"
					appearance="minimal"
					type="bp"
					icon="trash"
					disabled
					@click="deleteSetup(item)"
				/>
			</template>
		</t-grid>
		<EditInboundSettings
			ref="editInboundSettings"
			:isDialogShown="showEditSetupDialog"
			:inboundEdiSetting="setting"
			@close="showEditSetupDialog = false"
			@cancel="showEditSetupDialog = false"
		/>
		<NewInboundSetup
			ref="addInboundSettings"
			:isDialogShown="showAddSetupDialog"
			@close="showAddSetupDialog = false"
			@cancel="showAddSetupDialog = false"
		/>
	</div>
</template>

<script>

import { mapGetters, mapActions } from './store/details/ediSetupDetails.store';
import EditInboundSettings from './editEdipart/EditInboundSettings';
import deepcopy from 'deepcopy';
import NewInboundSetup from './newEdipart/NewInboundSetup';

export default {
	components: { EditInboundSettings, NewInboundSetup },
	data() {
		return {
			showEditSetupDialog: false,
			showAddSetupDialog: false,
			setting: {},
			columnDefinitions: [
				{
					field: 'sender',
					displayName: this.$t('sender'),
					resizable: true,
					width: 150
				},
				{
					field: 'recipient',
					displayName: this.$t('receiver'),
					resizable: true,
					width: 150
				},
				{
					field: 'transportMethodDescription',
					displayName: this.$t('transportMethod'),
					resizable: true,
					width: 150
				},
				{
					field: 'endpoint',
					displayName: this.$t('endpoint'),
					resizable: true,
					width: 225
				},
				{
					field: 'messageTypeDescription',
					displayName: this.$t('messageType'),
					resizable: true,
					width: 150
				},
				{
					field: 'messageFormatDescription',
					displayName: this.$t('messageFormat'),
					resizable: true,
					width: 150
				},
				{
					field: 'ssl',
					displayName: this.$t('ftps'),
					resizable: true,
					width: 70
				},
				{
					field: 'allowUpdates',
					displayName: this.$t('allowUpdates'),
					resizable: true,
					width: 70
				},
				{
					field: 'endpointUsername',
					displayName: this.$t('endpointUsername'),
					resizable: true,
					width: 150
				},
				{
					field: 'endpointPassword',
					displayName: this.$t('endpointPassword'),
					resizable: true,
					width: 150
				},
				{
					field: 'button',
					displayName: this.$t('delete'),
					resizable: true,
				}
			],
			defaultColumnDefinition: { resizable: true },
		};
	},

	computed:{
		...mapGetters(['edipart']),

		hasSetupLines() {
			return this.edipart.inboundSetups.length > 0;
		}
	},

	created() {
		window.addEventListener('keydown', this.onKeyDown);
	},
	beforeDestroy() {
		window.removeEventListener('keydown', this.onKeyDown);
	},
	methods: {
		...mapActions(['executeDeleteSetup']),
		editSetting(value) {
			this.setting = deepcopy(this.edipart.inboundSetups.find(x => x.id === value));
			this.showEditSetupDialog = true;
		},
		onKeyDown(event) {
			if (event.key === 'Delete' && event.ctrlKey) {
				let items = this.$refs.inboundSettingsGrid.getSelectedItems();
				this.deleteSetup(items);
			}
		},
		deleteSetup(setups) {
			this.executeDeleteSetup({ setups, key: 'inboundSetups' });
			this.$notify({
				type: 'success',
				title: this.$t('notifySetupDeleted')
			});
		},

		showAddSetting() {
			this.showAddSetupDialog = true;
		},
		close() {
			this.showEditSetupDialog = false;
		},
	}


};
</script>

<style lang="scss" scoped>

</style>